import webApp from './webApp';

webApp.urlHashRouting.createStateTransition( 
  '', 
  '#/issue/:issueid(/:pageid)'
).on( function( params ) {

  var issueId = parseInt( params.issueid, 10 );
  var pageId = parseInt( params.pageid, 10 );

  if ( issueId ) {
    if ( webApp.networkStatus )
      handleOnlineTransition( issueId, pageId );
    else
      handleOfflineTransition( issueId, pageId );
  }
} );

function handleOnlineTransition( issueId, pageId ) {

  if ( webApp.issueReader.issue && webApp.issueReader.issue.id == issueId ) {
    if ( pageId )
      webApp.issueReader.goToPageId( pageId );
  }
  else if ( pageId ) {
    // Fix the current URL so that pressing the back-button won't 
    // navigate straight back to the issue
    window.history.replaceState( '', '', window.location.href.replace( /#.*$/, '' ) );
    window.location.href = webApp.env.site_url +'/asmag/web-app/idtopermalinkredirect/?issue='+ issueId +'&page='+ pageId;
  }
  else {
    // Fix the current URL so that pressing the back-button won't 
    // navigate straight back to the issue
    window.history.replaceState( '', '', window.location.href.replace( /#.*$/, '' ) );
    window.location.href = webApp.env.site_url +'/asmag/web-app/idtopermalinkredirect/?issue='+ issueId;
  }
}

function handleOfflineTransition( issueId, pageId ) {
  if ( webApp.issueReader.issue && webApp.issueReader.issue.id == issueId ) {
    if ( pageId )
      webApp.issueReader.goToPageId( pageId );
  }
}
